import { cmsAxiosInstance } from '../configuration/axiosConfig';
import { ClientResponse } from '../model/ClientResponse';
import Aktualita from '../model/Aktualita';

export const getAktualitaDetail = async (id: string | undefined):
  Promise<ClientResponse<Aktualita>> => {
  const {
    data,
    status,
  } = await cmsAxiosInstance.get(
    `/aktuality/${id}`,
  );

  return {
    data:
      {
        ...data,
        vypublikovane: data['mgnl:created'],
        id: data['@name'],
      },
    responseCode: status,
  };
};
